import React from "react";
import { Link, useLocation } from "react-router-dom";

const ServiceArea = [
  {
    label: "Göztepe Mahallesi Halı Yıkama",
    path: "/bagcilar/goztepe-hali-yikama",
    description:
      "Göztepe Mahallesi’nde halılarınız tam otomatik sistemlerle hijyenik şekilde temizlenir, adresinize teslim edilir."
  },
  {
    label: "Yüzyıl Mahallesi Halı Yıkama",
    path: "/bagcilar/yuzyil-hali-yikama",
    description:
      "Yüzyıl Mahallesi’nde antibakteriyel ürünlerle çevre dostu halı yıkama hizmeti sunuyoruz."
  },
  {
    label: "Kirazlı Mahallesi Halı Yıkama",
    path: "/bagcilar/kirazli-hali-yikama",
    description:
      "Kirazlı Mahallesi'nde halı yıkama hizmetimizde kapıdan alım ve teslimat ücretsizdir, kaliteli temizlik garantili."
  },
  {
    label: "Bağlar Mahallesi Halı Yıkama",
    path: "/bagcilar/baglar-hali-yikama",
    description:
      "Bağlar Mahallesi’ne özel hızlı servisle halılarınız kısa sürede derinlemesine temizlenerek teslim edilir."
  },
  {
    label: "Sancaktepe Mahallesi Halı Yıkama",
    path: "/bagcilar/sancaktepe-hali-yikama",
    description:
      "Sancaktepe bölgesinde hem bireysel hem ticari müşterilere profesyonel halı yıkama çözümleri sunuyoruz."
  },
  {
    label: "Yenigün Mahallesi Halı Yıkama",
    path: "/bagcilar/yenigun-hali-yikama",
    description:
      "Yenigün Mahallesi’nde organik deterjanlarla sağlıklı halı temizliği hizmeti sunmaktayız."
  },
  {
    label: "Fatih Mahallesi Halı Yıkama",
    path: "/bagcilar/fatih-hali-yikama",
    description:
      "Fatih Mahallesi’nde halılarınız profesyonel sistemlerde el değmeden temizlenir, güvenle teslim edilir."
  },
  {
    label: "Demirkapı Mahallesi Halı Yıkama",
    path: "/bagcilar/demirkapi-hali-yikama",
    description:
      "Demirkapı bölgesine sunduğumuz halı yıkama servisimiz hijyenik ve zamanında teslimat garantilidir."
  }
];

const BagcilarSidebar = () => {
  const location = useLocation();

  return (
    <div className="mt-2 text-[#003132]">
      <h2 className="text-lg font-semibold mb-2 uppercase tracking-wide text-center">BAĞCILAR SERVİS ALANLARI</h2>

      <div className="bg-[#f1f5f9] p-4 rounded-xl shadow-sm space-y-3 border border-gray-200">
        {ServiceArea.map((area, index) => (
          <div key={index}>
            <Link
              to={area.path}
              className={`block text-sm font-semibold px-3 py-1 rounded-lg transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-red-600 text-white"
                  : "text-red-900 hover:bg-green-100 hover:text-red-800"
              }`}
            >
              {area.label}
            </Link>
            <p className="text-xs text-gray-600 mt-1 pl-1">{area.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BagcilarSidebar;
